import React from 'react';
import { socialData } from '../data/siteContent';
import { Instagram, Youtube, Music, Video, Twitch as TwitchIcon, Radio } from 'lucide-react';

const Social = () => {
  const getIcon = (platform) => {
    switch (platform) {
      case 'Instagram':
        return <Instagram className="w-12 h-12" />;
      case 'YouTube':
        return <Youtube className="w-12 h-12" />;
      case 'SoundCloud':
        return <Music className="w-12 h-12" />;
      case 'TikTok':
        return <Video className="w-12 h-12" />;
      case 'Twitch':
        return <TwitchIcon className="w-12 h-12" />;
      case 'MixCloud':
        return <Radio className="w-12 h-12" />;
      default:
        return null;
    }
  };

  return (
    <section className="relative py-20 bg-black">
      {/* DJ NEFF Logo Watermark */}
      <div className="absolute inset-0 opacity-5 pointer-events-none overflow-hidden">
        <div className="flex flex-col h-full justify-around">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex justify-around whitespace-nowrap">
              {[...Array(4)].map((_, j) => (
                <img
                  key={j}
                  src="https://customer-assets.emergentagent.com/job_professional-epk/artifacts/k20ff6ft_IMG_4353_2-removebg-preview.png"
                  alt=""
                  className="w-32 h-32 md:w-40 md:h-40 object-contain"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-12 text-center">
          {socialData.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {socialData.platforms.map((platform, index) => (
            <a
              key={index}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-4 p-8 border-2 border-white bg-transparent hover:bg-white transition-all duration-300"
            >
              <div className="text-white group-hover:text-black transition-colors duration-300">
                {getIcon(platform.name)}
              </div>
              <div className="text-center">
                <p className="text-white group-hover:text-black font-black text-xl mb-1 transition-colors duration-300">
                  {platform.name}
                </p>
                <p className="text-gray-300 group-hover:text-gray-700 text-sm transition-colors duration-300">
                  {platform.handle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Social;